export const snakeCaseToCamelCase = (snakeStr: string): string => {
  return snakeStr.replace(/(_\w)/g, (match) => match[1].toUpperCase());
};
